var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"users-list"},_vm._l((_vm.users),function(user){return _c('UsersListItem',{key:user.id,attrs:{"user":user,"user-statuses":_vm.userStatuses},on:{"click":function($event){return _vm.$emit('open-profile', $event)}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }